/**
 * ImaginePay API
 * This API facilitates partner integration within the platform.
 *
 * The version of the OpenAPI document: 25_6_2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ImaginePayApiModelsPaymentPlanPaymentPlanLookUpResult {
  readonly paymentPlanId: number;
  readonly paymentRequestId: number;
  readonly planName?: string;
  readonly length?: number;
  readonly minBalanceRequirement?: number;
  readonly maxBalanceRequirement?: number;
  readonly initialPaymentMode?: string;
  readonly minInitialPaymentRequirement?: number;
  message?: string;
}
